import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { SEARCH } from '@constants/routes';
import { trackClickEvent } from '@utils/analytics';
import searchIcon from '../../images/icons/search.svg';
import s from './FactFileSearchInput.module.scss';

const FactFileSearchInput = () => {
  const router = useRouter();
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = () => {
    const url = searchValue ? `${SEARCH}?term=${searchValue}&filter=fact-files` : SEARCH;
    trackClickEvent({
      destination_url: url,
      label: 'Search Fact File',
      location: 'Hero',
      vertical_index: 1,
      horizontal_index: 0,
    });
    router.push(url);
  };

  const handleChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      handleSearch();
    }
  };
  return (
    <div className={s.root}>
      <div className={s.searchInputWrapper}>
        <input
          type="text"
          placeholder="Search fact files..."
          data-testid="searchInput"
          className={s.searchInput}
          value={searchValue}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        <button type="button" onClick={handleSearch} className={s.searchBtn}>
          <img src={searchIcon} alt="search icon" />
        </button>
      </div>
    </div>
  );
};

export default FactFileSearchInput;
